import './footer.scss';

import React from 'react';
import { Translate } from 'react-jhipster';
import { Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faExclamationTriangle, faArrowAltCircleRight, faPencilAlt, faTimes } from '@fortawesome/free-solid-svg-icons';

const Footer = props => (
  <div className="div-footter ">
    <footer className="footer">
      <div className="footer-bottom">
        {/* <div className="container">
          <div className="add">
            <p>Cơ quan chủ quản: Văn phòng Chính phủ</p>
          </div>
          <div className="add">
            <p>www.dichvucong.gov.vn</p>
          </div>
          <div className="add">
            <p>Tổng đài hỗ trợ: 18001096</p>
          </div>
          <div className="add">
            <p> Email: dichvucong@chinhphu.vn</p>
          </div>
        </div> */}
        <p>Bản quyền thuộc Bộ Nông nghiệp và Môi trường</p>
      </div>
    </footer>
  </div>
);

export default Footer;
